import { z } from 'zod';
import { phoneSchema } from '../shared/phone-fax';
export const dencValidationSchema = z.object({
    id: z.string(),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
    data: z
        .object({
        serviceTypes: z.enum(['SN', 'PT', 'OT', 'ST', 'HHA', 'MSW', 'Others']).array().min(1, 'At least one service type is required'),
        serviceTypeOther: z.string().optional(),
        facts: z.string().min(1, 'Facts used to make this decision are required'),
        detailedExplanation: z.string().min(1, 'Detailed explanation is required'),
        specificPlanPolicy: z.string().optional(),
        contactPhone: phoneSchema,
        patientSigned: z.literal(true, {
            errorMap: () => ({ message: 'Patient signature is required' }),
        }),
        signedDate: z.string(),
    })
        .superRefine((data, ctx) => {
        if (data.serviceTypes.includes('Others') && !data.serviceTypeOther?.trim()) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['serviceTypeOther'],
                message: 'Please specify the other service type',
            });
        }
        if (data.patientSigned && !data.signedDate) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['signedDate'],
                message: 'Signature date is required',
            });
        }
    }),
});
